import { render, staticRenderFns } from "./editprofilepicture.vue?vue&type=template&id=a6459f5c&scoped=true&"
import script from "./editprofilepicture.vue?vue&type=script&lang=js&"
export * from "./editprofilepicture.vue?vue&type=script&lang=js&"
import style0 from "./editprofilepicture.vue?vue&type=style&index=0&id=a6459f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6459f5c",
  null
  
)

export default component.exports